var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListFilter',{attrs:{"options":_vm.options,"categories":_vm.categories,"filterId":"stocks","filterName":"Stocks","iconClass":"fa fa-boxes"},on:{"hovering":_vm.onHovering,"editing":_vm.onEditing},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }